<div class="top-header" *ngIf="backRouterLink && backRouterLinkLabel">
  <a mat-button [routerLink]="backRouterLink" queryParamsHandling="preserve" class="top-header__go-back text-primary-hover">
    <mat-icon>navigate_before</mat-icon>
    {{ backRouterLinkLabel | translate }}
  </a>
</div>
